module.exports = __webpack_public_path__ + "res/materialdesignicons-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/lumx/fonts/materialdesignicons-webfont.woff2?v=1.9.32
// module id = 113
// module chunks = 1